function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9 .39a1.5 1.5 0 00-2 0L1.5 5.33A1.5 1.5 0 001 6.44v7.06A1.5 1.5 0 002.5 15h2A1.5 1.5 0 006 13.5v-4a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v4a1.5 1.5 0 001.5 1.5h2a1.5 1.5 0 001.5-1.5V6.44a1.5 1.5 0 00-.5-1.11L9 .39z",
  fill: "#F8F9FA"
}));